import React, { useState } from 'react';
import { createCheckoutSession } from '../lib/stripe';
import { Loader2, CreditCard } from 'lucide-react';
import { PRODUCTS } from '../stripe-config';

interface StripeCheckoutButtonProps {
  plan: 'PRO' | 'BUSINESS';
  interval: 'MONTHLY' | 'YEARLY';
  className?: string;
  children: React.ReactNode;
}

export default function StripeCheckoutButton({ 
  plan, 
  interval, 
  className = '', 
  children 
}: StripeCheckoutButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const priceId = PRODUCTS[plan][interval].priceId;
      await createCheckoutSession(priceId);
      // No need to set loading to false as we're redirecting to Stripe
    } catch (error) {
      console.error('Checkout error:', error);
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCheckout}
      disabled={loading}
      className={`${className} ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <Loader2 className="animate-spin h-5 w-5 mr-2" />
          Processing...
        </span>
      ) : (
        <span className="flex items-center justify-center">
          <CreditCard className="h-5 w-5 mr-2" />
          {children}
        </span>
      )}
    </button>
  );
}